import { differenceInDays, eachDayOfInterval } from 'date-fns';

import type { Absence as AbsenceType } from '../types';
import type { Interval } from 'components/types';

import { fromISOString } from 'utils/date';

export const MARGIN = 8; // px
export const PADDING = 8; // px

export const getAbsenceCoords = (
  { start, end }: AbsenceType,
  interval: Interval
) => {
  const daysOfIntervalNr = eachDayOfInterval({
    start: interval.startDate,
    end: interval.endDate
  }).length;

  const endTime = new Date(fromISOString(end).getTime() - 1000);
  const startDiff = differenceInDays(fromISOString(start), interval.startDate);
  const endDiff = differenceInDays(interval.endDate, endTime);

  const leftPos = Math.max(0, startDiff);
  const rightPos = daysOfIntervalNr - leftPos - Math.max(0, endDiff);

  const marginLeft = (leftPos / daysOfIntervalNr) * 100;
  const width = (rightPos / daysOfIntervalNr) * 100;

  const isStartingEarly = fromISOString(start) < interval.startDate;
  const isEndingLate = endTime > interval.endDate;

  return { marginLeft, width, isStartingEarly, isEndingLate };
};
